import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[AllowNumberOnlyPosNeg]'
})
export class AllowNumberOnlyPosNegDirective {

  // Regular expression to allow only digits, plus (+), minus (-), and dot (.)
  ALLOWED_CHARACTERS = new RegExp(/[^0-9+-.]/g);

  constructor(private el: ElementRef) {
    // Sanitize clipboard by removing any non-numeric input after pasting
    this.el.nativeElement.onpaste = (e: ClipboardEvent) => {
      e.preventDefault();
      let text;
      const clipboardData = e.clipboardData || (window as any).clipboardData;
      text = clipboardData.getData('text') || '';

      if (text !== '') {
        text = text.replace(this.ALLOWED_CHARACTERS, ''); // Remove invalid characters
        document.execCommand('insertText', false, text);
      }
    };
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;

    // Allow control keys: Backspace, Delete, Tab, Escape, Enter, Arrow keys, etc.
    if (
      [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 || // Basic control keys
      (e.keyCode >= 35 && e.keyCode <= 40) || // Home, End, Arrow keys
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) || // Ctrl+A (Select All)
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) || // Ctrl+C (Copy)
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) || // Ctrl+V (Paste)
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) // Ctrl+X (Cut)
    ) {
      return; // Allow these keypresses
    }

    // Restrict invalid input: only digits, +, -, and .
    const isNumberKey =
      (e.keyCode >= 48 && e.keyCode <= 57) || // Numbers on main keyboard
      (e.keyCode >= 96 && e.keyCode <= 105); // Numbers on numpad
    const isPlusOrMinus = e.key === '+' || e.key === '-';
    const isDot = e.key === '.';

    if (!isNumberKey && !isPlusOrMinus && !isDot) {
      e.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const sanitizedValue = inputElement.value.replace(this.ALLOWED_CHARACTERS, '');
    if (inputElement.value !== sanitizedValue) {
      inputElement.value = sanitizedValue; // Remove invalid characters in real-time
    }
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src2927200756/src/src/app/shared/directive/allow-number-only-pos-neg.directive.ts